<template>
  <b-modal
    v-model="$show"
    centered
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
    size="md"
    title="Certificate Sample"
  >
    <template>
      <div ref="modal__certificate-detail" class="modal__certificate-detail">
        <div ref="text__certificate-username" class="text__certificate-username">
          <span ref="text__certificate-firstname" class="text__certificate-firstname">
            {{ firstname }}
          </span>

          <div ref="text__certificate-lastname" class="text__certificate-lastname">
            {{ lastname }}
          </div>
        </div>
        <b-img
          ref="img-certificate"
          class="img-certificate"
          :src="require('@/assets/mc-certificate-example/mc-certificate-example-01.svg')"
          fluid
        />
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="link" class="btn-link-dark" @click="close()"> Close </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  model: {
    prop: 'show',
    event: 'update:show'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },

    noCloseOnBackdrop: {
      type: Boolean,
      default: true
    },

    noCloseOnEsc: {
      type: Boolean,
      default: true
    },

    firstname: {
      type: String,
      required: true
    },

    lastname: {
      type: String,
      required: true
    }
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.modal__certificate-detail {
  position: relative;
  text-align: center;
}

.text__certificate-username {
  font-size: 12px;
  font-weight: 700;
  text-align: start;
  position: absolute;
  top: 30.5%;
  left: 49%;
}

.text__certificate-lastname {
  display: inline-block;
}

@media screen and (min-width: 375px) {
  .text__certificate-username {
    font-size: 14px;
  }
}

@media screen and (min-width: 425px) {
  .text__certificate-username {
    font-size: 18px;
  }
}

@media screen and (min-width: 576px) {
  .text__certificate-username {
    font-size: 20px;
  }
}
</style>
